export default __webpack_public_path__ + "static/media/todo-app.f0b2a09b.png";